(() => {
  if (customElements.get('joa-customer-gallery')) return;
  class JoaCustomerGallery extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.dialog = this.querySelector('dialog');
      if (!this.dialog?.showModal) return;
      try {
        this.photos = JSON.parse(this.querySelector('[data-joa-gallery-data]').textContent);
        this.copy = JSON.parse(this.querySelector('[data-joa-gallery-copy]').textContent);
      } catch { return; }
      if (!this.photos.length) return;
      this.initialized = true;
      this.renderCarousel();
      this.filtered = this.photos;
      this.filter = this.querySelector('[data-joa-gallery-filter]');
      for (const shape of new Set(this.photos.map(photo => photo.shape))) {
        const option = document.createElement('option');
        option.value = shape; option.textContent = shape;
        this.filter.append(option);
      }
      this.querySelector('.joa-customer-gallery__view').hidden = false;
      this.filter.addEventListener('change', () => {
        this.filtered = this.filter.value === 'all' ? this.photos : this.photos.filter(photo => photo.shape === this.filter.value);
        this.renderGrid();
      });
      this.addEventListener('click', event => {
        const browse = event.target.closest('[data-joa-gallery-browse]');
        const opener = event.target.closest('[data-joa-gallery-open]');
        if (browse || opener) {
          event.preventDefault();
          this.opener = browse || opener;
          if (browse) this.showBrowser(false);
          else {
            this.filter.value = 'all'; this.filtered = this.photos;
            this.showPhoto(this.photos.findIndex(photo => photo.id === opener.dataset.joaGalleryOpen), false);
          }
          this.dialog.showModal();
        } else if (event.target.closest('[data-joa-carousel-prev]')) this.moveCarousel(-1);
        else if (event.target.closest('[data-joa-carousel-next]')) this.moveCarousel(1);
        else if (event.target.closest('[data-joa-gallery-close]')) this.dialog.close();
        else if (event.target.closest('[data-joa-gallery-back]')) this.showBrowser(true);
        else if (event.target.closest('[data-joa-gallery-prev]')) this.showPhoto(this.current - 1, false);
        else if (event.target.closest('[data-joa-gallery-next]')) this.showPhoto(this.current + 1, false);
        else {
          const thumb = event.target.closest('[data-joa-gallery-thumb]');
          if (thumb) { this.showPhoto(Number(thumb.dataset.joaGalleryThumb), true); }
        }
      });
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const box = this.dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
      });
      this.dialog.addEventListener('keydown', event => {
        if (this.querySelector('[data-joa-gallery-viewer]').hidden) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();this.showPhoto(this.current + (event.key === 'ArrowLeft' ? -1 : 1), false);
        }
      });
      this.dialog.addEventListener('close', () => this.opener?.focus({preventScroll: true}));
    }
    renderCarousel() {
      this.rail = this.querySelector('.joa-customer-gallery__mosaic');
      const existing = [...this.rail.querySelectorAll('[data-joa-gallery-open]')];
      const ids = new Set(existing.map(item => item.dataset.joaGalleryOpen));
      const fragment = document.createDocumentFragment();
      for (const photo of this.photos) {
        if (ids.has(photo.id)) continue;
        const link = document.createElement('a');
        link.className = 'joa-customer-gallery__photo';
        link.href = photo.src;
        link.dataset.joaGalleryOpen = photo.id;
        link.setAttribute('aria-label', photo.alt);
        const image = this.image(photo, 720);
        image.loading = 'lazy';
        link.append(image);
        fragment.append(link);
      }
      this.rail.append(fragment);
      this.slides = [...this.rail.querySelectorAll('[data-joa-gallery-open]')];
      this.querySelector('.joa-customer-gallery__carousel-controls').hidden = false;
      this.carouselIndex = 0;
      const update = () => {
        const edge = this.rail.getBoundingClientRect();
        const rtl = getComputedStyle(this.rail).direction === 'rtl';
        let nearest = 0, distance = Infinity;
        this.slides.forEach((slide, index) => {
          const box = slide.getBoundingClientRect();
          const delta = Math.abs(rtl ? edge.right - box.right : box.left - edge.left);
          if (delta < distance) { distance = delta; nearest = index; }
        });
        this.carouselIndex = nearest;
        this.querySelector('[data-joa-carousel-counter]').textContent = `${nearest + 1} / ${this.slides.length}`;
        this.querySelector('[data-joa-carousel-prev]').disabled = nearest === 0;
        this.querySelector('[data-joa-carousel-next]').disabled = nearest === this.slides.length - 1;
      };
      this.rail.addEventListener('scrollend', update);
      this.rail.addEventListener('scroll', () => {
        clearTimeout(this.carouselTimer);
        this.carouselTimer = setTimeout(update, 160);
      }, {passive: true});
      update();
    }
    moveCarousel(direction) {
      const index = Math.max(0, Math.min(this.carouselIndex + direction, this.slides.length - 1));
      this.slides[index]?.scrollIntoView({block: 'nearest', inline: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    }
    disconnectedCallback() {
      clearTimeout(this.carouselTimer);
    }
    image(photo, width) {
      const image = new Image();
      const url = new URL(photo.src, location.href);
      if (url.protocol === 'https:' || url.protocol === 'http:') url.searchParams.set('width', String(Math.min(width, photo.width)));
      // Keep embedded local review previews intact during offline QA.
      image.src = url.href;
      image.alt = photo.alt;
      image.width = photo.width; image.height = photo.height;
      image.decoding = 'async';
      return image;
    }
    renderGrid() {
      const fragment = document.createDocumentFragment();
      this.filtered.forEach((photo,index) => {
        const button = document.createElement('button');
        button.type = 'button';button.className = 'joa-customer-gallery__thumb';
        button.dataset.joaGalleryThumb = index;
        button.setAttribute('aria-label', photo.alt);
        const image = this.image(photo,360);image.loading = 'lazy';
        button.append(image);fragment.append(button);
      });
      this.querySelector('[data-joa-gallery-grid]').replaceChildren(fragment);
      this.querySelector('[data-joa-gallery-total]').textContent = `${this.filtered.length} ${this.copy.photos}`;
      this.gridReady = true;
    }
    showBrowser(restoreFocus) {
      this.querySelector('[data-joa-gallery-viewer]').hidden = true;
      this.querySelector('[data-joa-gallery-browser]').hidden = false;
      this.renderGrid();
      if (restoreFocus) this.querySelector(`[data-joa-gallery-thumb="${this.current}"]`)?.focus({preventScroll:true});
    }
    showPhoto(index,focusBack) {
      this.current = Math.max(0,Math.min(index,this.filtered.length - 1));
      const photo = this.filtered[this.current];
      this.querySelector('[data-joa-gallery-browser]').hidden = true;
      this.querySelector('[data-joa-gallery-viewer]').hidden = false;
      this.querySelector('.joa-customer-gallery__stage').replaceChildren(this.image(photo,1800));
      this.querySelector('[data-joa-gallery-credit]').textContent = `${this.copy.photo_by} ${photo.credit}`;
      this.querySelector('[data-joa-gallery-counter]').textContent = `${this.current + 1} / ${this.filtered.length}`;
      this.querySelector('[data-joa-gallery-prev]').disabled = this.current === 0;
      this.querySelector('[data-joa-gallery-next]').disabled = this.current === this.filtered.length - 1;
      if (focusBack) this.querySelector('[data-joa-gallery-back]').focus({preventScroll:true});
    }
  }
  customElements.define('joa-customer-gallery',JoaCustomerGallery);
})();

